// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QlJh","image":"Header_image___qIWu","name":"Header_name__3elkM","info":"Header_info__aaAWo","infoRow":"Header_infoRow__12VG6"};